import axios from 'axios';
// import QueryString from 'qs';
import { generateQueryParams } from 'utils/generateQueryParams';

export const DocumentsService = {
  async getDocuments(page, perPage, filters, tribe_id) {
    const params = generateQueryParams({
      page,
      size: perPage,
      ...filters,
      tribe_id: tribe_id === 3 ? null : tribe_id,
    });

    const res = await axios.get('org/v1/pf/docs-list/', {
      params,
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async setDocumentNumeration(payload) {
    const res = await axios.post('org/v1/numeration/', payload);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async deleteDocument(docId, clientId) {
    const res = await axios.delete(
      `org/v1/pf/delete_docs/pdf/${clientId}/${docId}/`
    );

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async getInvoicePayment(clientId, docId) {
    const res = await axios.get(
      `org/v1/pf/invoiceForPayment/pdf/${clientId}/${docId}/`
    );

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async createInvoicePayment(payload) {
    const res = await axios.post('org/v1/pf/invoiceForPayment/pdf/', payload);

    if (res.status === 201) {
      return res.data;
    }

    return Promise.reject();
  },

  async createReconcilliationStatemnet(payload) {
    const res = await axios.post('org/v1/act-of-reconciliataion/pre/', payload);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
  async createReconcilliationStatemnetFinal(payload) {
    const res = await axios.post('org/v1/act-of-reconciliataion/', payload);

    if (res.status === 201) {
      return res.data;
    }

    return Promise.reject();
  },

  async editInvoicePayment(payload, clientId, docId) {
    const res = await axios.put(
      `org/v1/pf/invoiceForPayment/pdf/${clientId}/${docId}/`,
      payload
    );

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getSalaryReference(clientId, docId) {
    const res = await axios.get(`org/v1/pf/salary/pdf/${clientId}/${docId}/`);

    if (res.status === 200) {
      return res.data;
    }
    return Promise.reject();
  },

  async createSalaryReference(payload) {
    const res = await axios.post('org/v1/pf/salary/pdf/', payload);

    if (res.status === 201) {
      return res.data;
    }
    return Promise.reject();
  },

  async editSalaryReference(payload, clientId, docId) {
    const res = await axios.put(
      `org/v1/pf/salary/pdf/${clientId}/${docId}/`,
      payload
    );

    if (res.status === 200) {
      return res.data;
    }
    return Promise.reject();
  },

  async createCertificateOfEmployment(payload) {
    const res = await axios.post('org/v1/pf/certificateOfemployment/', payload);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getReturnNote(clientId, docId) {
    const res = await axios.get(
      `org/v1/pf/return_note/pdf/${clientId}/${docId}/`
    );

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async createReturnNote(payload) {
    const res = await axios.post(`org/v1/pf/return_note/pdf/`, payload);

    if (res.status === 201) {
      return res.data;
    }

    return Promise.reject();
  },

  async editReturnNote(payload, clientId, docId) {
    const res = await axios.put(
      `org/v1/pf/return_note/pdf/${clientId}/${docId}/`,
      payload
    );

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getPowerAttorney(clientId, docId) {
    const res = await axios.get(`org/v1/pf/attorney/pdf/${clientId}/${docId}/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async createPowerAttorney(payload) {
    const res = await axios.post('org/v1/pf/attorney/pdf/', payload);

    if (res.status === 201) {
      return res.data;
    }

    return Promise.reject();
  },

  async editPowerAttorney(payload, clientId, docId) {
    const res = await axios.put(
      `org/v1/pf/attorney/pdf/${clientId}/${docId}/`,
      payload
    );

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getActOfCompletion(clientId, docId) {
    const res = await axios.get(
      `org/v1/pf/actOfCompletion/pdf/${clientId}/${docId}/`
    );

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async createActOfCompletion(payload) {
    const res = await axios.post('org/v1/pf/actOfCompletion/pdf/', payload);

    if (res.status === 201) {
      return res.data;
    }

    return Promise.reject();
  },

  async editActOfCompletion(payload, clientId, docId) {
    const res = await axios.put(
      `org/v1/pf/actOfCompletion/pdf/${clientId}/${docId}/`,
      payload
    );

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getGoodInvoice(clientId, docId) {
    const res = await axios.get(`org/v1/pf/note/pdf/${clientId}/${docId}/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async createGoodInvoce(payload) {
    const res = await axios.post(`org/v1/pf/note/pdf/`, payload);

    if (res.status === 201) {
      return res.data;
    }

    return Promise.reject();
  },

  async editGoodInvoce(payload, clientId, docId) {
    const res = await axios.put(
      `org/v1/pf/note/pdf/${clientId}/${docId}/`,
      payload
    );

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getAccountInvoice(clientId, docId) {
    const res = await axios.get(`org/v1/pf/invoice/pdf/${clientId}/${docId}/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async createAccountInvoice(payload) {
    const res = await axios.post('org/v1/pf/invoice/pdf/', payload);

    if (res.status === 201) {
      return res.data;
    }

    return Promise.reject();
  },

  async editAccountInvoice(payload, clientId, docId) {
    const res = await axios.put(
      `org/v1/pf/invoice/pdf/${clientId}/${docId}/`,
      payload
    );

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getClientActAndNotes(clientId) {
    const res = await axios.get(`org/v1/pf/actsAndNotes/${clientId}/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getSelectedActOrNote(clientId, fileId) {
    const res = await axios.get(
      `org/v1/pf/actsAndNotes/${clientId}/${fileId}/`
    );

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
  // async getSelectedActOrNote(clientId, fileIds) {
  //   const params = {
  //     ids: fileIds,
  //   };

  //   const res = await axios.get(`org/v1/pf/merge-act-note/${clientId}/`, {
  //     params,
  //     paramsSerializer: (params) => {
  //       return QueryString.stringify(params, { arrayFormat: 'repeat' });
  //     },
  //   });

  //   if (res.status === 200) {
  //     return res.data;
  //   }

  //   return Promise.reject();
  // },

  async getClientInvoices(clientId) {
    const res = await axios.get(
      `org/v1/pf/invoiceForPayment/pdf/${clientId}/all/`
    );

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getSelectedInvoice(clientId, docId) {
    const res = await axios.get(
      `org/v1/pf/invoiceForPayment/pdf/${clientId}/${docId}/`
    );

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getClientNotes(clientId) {
    const res = await axios.get(`org/v1/pf/note/pdf/${clientId}/all/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getSelectedNote(clientId, docId) {
    const res = await axios.get(`org/v1/pf/note/pdf/${clientId}/${docId}/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async addIncomingDocument(formData, clientId) {
    const res = await axios.post(
      `org/v1/upload/documents/${clientId}/`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    if (res.status === 201) {
      return true;
    }

    return Promise.reject();
  },

  async downloadClientDocuments(clientId) {
    const res = await axios.get(`org/v1/download/documents/${clientId}/`);

    if (res.status === 200) {
      const fileUrl = res.data.url;

      const filesRes = await axios.get(`${fileUrl}/`, {
        responseType: 'blob',
      });

      if (filesRes.status === 200) {
        return {
          fileUrl,
          blob: filesRes.data,
        };
      }
    }

    return Promise.reject();
  },

  async generateExcel(docId) {
    const res = await axios.post(`org/v1/pf/generate_excel/${docId}/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async setFileStatus(payload, docId) {
    const res = await axios.put(
      `org/v1/fileclients/set-status/${docId}/`,
      payload
    );

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
};
